export default __webpack_public_path__ + "static/media/big_brothers_big_sisters.1f24f53e.png";